import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M20.5 3.5h-17v17h17v-17zM3.5 2H2v20h20V2H3.5z" fill="#000" /></svg>);